import React, { useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'react-jss';
import { Button, Input, Row } from 'antd';
import { useHistory } from 'react-router';
import { useForm, Controller } from 'react-hook-form';

import Breadcrumbs from '../Components/Breadcrumbs';
import styles from '../styles';
import { successNotification, errorNotification } from '../Snackbar';
import Api from '../Api';
import LeftGrid from '../Components/LeftGrid';
import RightGrid from '../Components/RightGrid';
import GetField from '../Components/GetField';

const AntInput = GetField(Input);

const AntInputTextArea = GetField(Input.TextArea);

const CreateWorker = props => {
  const { classes } = props;
  const history = useHistory();

  const { handleSubmit, control } = useForm();

  const [confirmLoading, setConfirmLoading] = useState(false);

  const onSubmit = async formValues => {
    try {
      setConfirmLoading(true);
      await Api.post('/workers', formValues);
      successNotification('Worker added');
      history.push('/workers/list');
    } catch (err) {
      setConfirmLoading(false);
      errorNotification(err);
    }
  };

  return (
    <>
      <Breadcrumbs
        moduleName="Workers"
        moduleLink="/workers/list"
        subModuleName="Create"
      />
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <LeftGrid>
            <Controller
              name="name"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  label="Name"
                  placeholder="Name"
                  {...field}
                />
              )}
            />
          </LeftGrid>
          <RightGrid>
            <Controller
              name="email"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  label="Email"
                  placeholder="Email"
                  {...field}
                />
              )}
            />
          </RightGrid>
        </Row>
        <Row>
          <LeftGrid>
            <Controller
              name="phone"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  label="Phone"
                  placeholder="Phone"
                  {...field}
                />
              )}
            />
          </LeftGrid>
          <RightGrid>
            <Controller
              name="address"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  label="Address"
                  placeholder="Address"
                  {...field}
                />
              )}
            />
          </RightGrid>
        </Row>
        <Row>
          <LeftGrid>
            <Controller
              name="comment"
              control={control}
              render={({ field }) => (
                <AntInputTextArea
                  allowClear
                  label="Remark"
                  placeholder="Remark"
                  {...field}
                />
              )}
            />
          </LeftGrid>
          <RightGrid>
            <Controller
              name="employeeId"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  label="Employee Id"
                  placeholder="Employee Id"
                  {...field}
                />
              )}
            />
          </RightGrid>
        </Row>
        <Row className={classes.buttonContainer}>
          <Button type="primary" loading={confirmLoading} htmlType="submit">
            Submit
          </Button>
        </Row>
      </form>
    </>
  );
};

CreateWorker.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CreateWorker);
